import { sanitizeReturnTo } from './returnTo.ts';

export function buildNativeResetLink(
  scheme: string,
  token: string,
  returnTo?: string | null
): string {
  const safeReturnTo = sanitizeReturnTo(returnTo);
  const url = `${scheme}reset-password?token=${encodeURIComponent(token)}`;

  if (!safeReturnTo) return url;

  return `${url}&returnTo=${encodeURIComponent(safeReturnTo)}`;
}
